import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { XCircle } from 'lucide-react';
const pains = [{
  title: 'El drenaje de tiempo manual:',
  desc: 'Horas perdidas limpiando Excels sucios, conciliando bancos y cargando facturas que una IA resuelve en segundos.'
}, {
  title: 'El techo de honorarios:',
  desc: 'Seguir cobrando por "el trámite" mientras la inflación te come el margen y no sabés cómo justificar un aumento real.'
}, {
  title: 'La esclavitud del WhatsApp:',
  desc: 'Clientes que ignoran tus límites porque no tenés un sistema de recepción de documentos profesional.'
}, {
  title: 'El riesgo de obsolescencia:',
  desc: 'La IA está cambiando las reglas en Argentina y el que no la domine hoy, estará fuera del mercado en 24 meses.'
}];
export function PainPoints() {
  return <section className="py-20 relative" data-id="element-247">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-248">
        <FadeIn data-id="element-249">
          <h2 className="text-3xl md:text-5xl font-bold text-center mb-8 leading-tight" data-id="element-250">
            ❌ ¿CUÁNTOS MARTES A LAS 23:30 MÁS VAS A PASAR ASÍ?
          </h2>

          <div className="bg-brand-card border border-slate-800 p-8 rounded-2xl mb-12" data-id="element-251">
            <p className="text-2xl md:text-3xl font-bold text-white leading-tight" data-id="element-252">
              Estudiaste para asesorar.
            </p>
            <p className="text-2xl md:text-3xl font-bold text-white mb-6 leading-tight" data-id="element-253">
              Terminaste apagando incendios por monedas.
            </p>

            <p className="text-lg text-slate-400 leading-relaxed" data-id="element-254">
              Clientes que te consumen el día.
            </p>
            <p className="text-lg text-slate-400 leading-relaxed" data-id="element-255">
              Honorarios que no reflejan lo que valés.
            </p>
            <p className="text-lg text-slate-400 mb-6 leading-relaxed" data-id="element-256">
              La IA avanzando… y vos sin sistema.
            </p>

            <p className="text-xl font-bold text-white" data-id="element-257">No estás atrasado.</p>
            <p className="text-xl font-bold text-brand-accent" data-id="element-258">
              Estás trabajando con el modelo equivocado.
            </p>
          </div>
        </FadeIn>

        <div className="space-y-4 mb-16" data-id="element-259">
          {pains.map((pain, i) => <FadeIn key={i} delay={i * 0.1} direction="left" data-id="element-260">
              <div className="flex items-start gap-4 bg-red-950/20 border border-red-900/30 p-4 rounded-xl" data-id="element-261">
                <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-262" />
                <p className="text-slate-200" data-id="element-263">
                  <span className="font-bold text-white" data-id="element-264">{pain.title}</span>{' '}
                  {pain.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} className="text-center" data-id="element-265">
          <h3 className="text-2xl md:text-4xl font-bold text-brand-accent mb-4" data-id="element-266">
            ¿Y si este fuera el último martes que pasás así?
          </h3>
        </FadeIn>
      </div>
    </section>;
}